import React, { useMemo } from 'react';
import ReactTable from 'react-table';
import { getMinRowsInTable } from '../../utils';

const LinkLocationList = ({data, handleSelection, selectedClientLocation, className, loading}) => {
    const getButtonClassName = (id) => {
        if(selectedClientLocation.id === id || !selectedClientLocation.id){
            return "btn btn-primary";
        }
        return "btn btn-default";
    };
    const columns = useMemo(() => {
        return([ 
            {
                id: 'locationName',
                Header: 'Location Name',
                accessor: x => x.locationName,
                Cell: row => <div className='pl-h'>{row.original.locationName}</div>                           
            },
            {
              id: "select",
              accessor: (x) => x.selected,
              Header: "",
              maxWidth: 160,
              sortable: false,
              Cell: (row) => (
                <div className="flex justify-content-center">
                  <button
                    className={`btn ${getButtonClassName(row.original.id)}`}
                    onClick={() => handleSelection({id: row.original.id, type: "location"})}
                  >
                    Select
                  </button>
                </div>
              ),
            }
        ]);
    },[data, selectedClientLocation.id]);
    return(
        <ReactTable
            sortable={false}
            filterable={false}
            showPagination={false}
                // mustBeArray(data).length !== 0}
            data={data}
            // defaultPageSize={5}
            columns={columns}
            minRows={getMinRowsInTable(data, 5)} 
            className={`${className || ""} scroll-table`}
            loading={loading}
        />
    );
};
export default LinkLocationList;